/**
 * 美小（美团微信小程序）按需登录功能
 *
 *
 * 核心机制：
 * - 通过 f_xxx 参数控制容器行为
 * - f_token=0, f_userId=0: 不自动唤起登录，但传递登录信息（如果已登录）
 * - f_token=1, f_userId=1: 自动唤起登录
 * - 如果后续美小环境需要新增登陆的参数也需要从这里获取
 * - f_xxx 中的 xxx 会成为容器传递给H5的 query 参数名
 *
 * 实现方式：
 * - 使用 wx.miniProgram.redirectTo 刷新当前容器页
 * - 容器检测到 f_token=1 后，内部会调用小程序登录API
 * - H5 不直接调用 accountSDK，由容器内部处理
 */

import { isServer } from "./constant";

/**
 * 在美小环境中唤起登录
 *
 * 使用 redirectTo 刷新当前容器页，并设置 f_token=1&f_userId=1 唤起登录
 *
 * 适用场景：
 * - 页面初始化时设置 f_token=0&f_userId=0（不强制登录，但获取登录信息）
 * - 用户执行需要登录的操作时，调用此方法唤起登录
 * - 登录成功后，容器会自动回到当前页面，并在URL中添加 ?token=xxx&userId=xxx
 *
 */
export function invokeMiniProgramLogin(): void {
  if (isServer || !window.wx?.miniProgram) {
    console.error("[MiniProgramLogin] 不在美小环境中");
    return;
  }

  // 获取当前页面URL
  const currentUrl = window.location.href;

  // 构建容器URL，设置 f_token=1&f_userId=1 唤起登录
  // 容器路径：/wp-h5-pages/pages/h5/index
  // 参数：
  // - f_token=1: 唤起登录（容器会调用小程序登录API）
  // - f_userId=1: 获取userId（登录成功后容器会传递 ?userId=xxx）
  // - weburl: 当前H5页面URL（登录成功后回跳）
  // /wp-h5-pages/pages/h5/index?f_token=0&f_userId=0&f_openId=0&f_openIdCipher=0&weburl=http%3A%2F%2Fmsstest.vip.sankuai.com%2Fstatic-test01%2Fcom.sankuai.mtunion.c.h5%2Fdistribution-center%2Fclient%2Findex.html%3FuserId%3D5115998710%26token%3DAgHjIstKOPD-V2ZeDaKA07d5Bt8hlf-QpIdHJwvonBaEBNHJjfoOnblM87aM4uFLYlWVQkQ_vVGcsgAAAABMIQwAoc8QmRnOMFlX6-xRBC3kpPnO__40ceXOmfkVc8TKMZtSwz9DpPoPWEPjBRI3Gmsj
  const containerUrl = `/wp-h5-pages/pages/h5/index?f_token=1&f_userId=1&f_openId=1&f_openIdCipher=1&weburl=${encodeURIComponent(
    currentUrl,
  )}`;
  console.log("[MiniProgramLogin] 唤起登录, 容器URL:", containerUrl);
  window.wx.miniProgram.navigateTo({
    url: containerUrl,
  });
}
